import React, {FC, useState} from 'react';
import {Icon} from '../components/Icon';
import Modal from "@mui/material/Modal";
import TERMS_TEXT from '../constants/terms';
import NewLineText from '../common/NewLineText';

interface TermsPopupProps {
  open: boolean;
  onClose: () => void;
}

export const TermsPopup: FC<TermsPopupProps> = ({
                                                  onClose,
                                                  open,
                                                }) => {

  return (
      <Modal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className={`flex justify-center items-center`}
      >
        <div
            className={`bg-white max-w-md w-full py-6 px-6 flex flex-col gap-y-5 md:h-5/6 h-full overflow-y-auto`}>
          <div className={`text-16 font-bold flex justify-between items-center`}>서비스 이용 약관 <Icon.X
              onClick={onClose} className={`cursor-pointer`}/></div>
          <div className={`text-12`}>
            <NewLineText text={TERMS_TEXT}/>
          </div>
        </div>
      </Modal>
  );
};
